/**
 * A map of xml entities and their symbols
 * @type {object}
 */
export const XML_MAP: { [key: string]: string } = {amp:"&",apos:"'",gt:">",lt:"<",quot:"\""};